// FooterMenu.js
import React from "react";
import "../styles/FooterMenu.css";

const FooterMenu = () => {

  const menuItems = [
    // { label: "Produits", link: "/products" },
    { label: "Compte", link: "https://billing.stripe.com/p/login/5kA2aC7yh6qA2mQfYY", target: "_blank" },
    { label: "Contact & SAV", link: "/contact" },
    { label: "Pour les entreprises", link: "/enterprise" },
    { label: "Pour les villes", link: "/cities" },
    { label: "L'histoire", link: "/about" },
    { label: "F.A.Q", link: "/foire-aux-questions" },
  ];

  return (
    <div className="footer-container">
      <div className="footer-details">
        <p>
          Baltee Mobility s'engage à améliorer la mobilité urbaine grâce à des
          solutions innovantes de sécurité pour les vélos, les trottinettes
           et autres dispositifs de micro-mobilité. Nos produits
          sont conçus pour rendre vos déplacements plus sûrs et plus durables.
        </p>
        <p>
          Les produits Baltee sont disponibles dans certaines régions, avec une
          expansion prévue dans de nouveaux lieux prochainement. Les
          fonctionnalités et la disponibilité peuvent varier selon les régions.
          Pour toute question, veuillez contacter notre service d'assistance.
        </p>
      </div>

      <div className="footer-menu">
        {menuItems.map((item, index) => (
          <div key={index} className="menu-item">
              <a className="menu-button" href={item.link} target={item.target}>{item.label}</a>
          </div>
        ))}
      </div>

      <div className="footer-links">
        <p>
          Autres moyens d'achat :{" "}
          <a href="/reseller">Trouver un distributeur Baltee</a>.
        </p>
        <p>France</p>
        <p>
          Copyright © 2025 Baltee Mobility. Tous droits réservés.
          <br />
          <a href="/cgu">Conditions générale d'utilisation</a> |{" "}
          <a href="/cgv">Conditions générale de ventes</a> |{" "}
          <a href="/legal-notice">Mentions légales</a>
        </p>
      </div>
    </div>
  );
};

export default FooterMenu;
